import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../api";
import i18n from "../../i18n";
import { humanizeError } from "../../utils/errorText";

const port = process.env.REACT_APP_BACKEND_PORT;

const initialState = {
  login: {
    state: {
      loading: false,
      success: false,
      error: null,
    },
    auth: null,
  },
  logout: {
    loading: false,
    success: false,
    error: null,
  },
};

/** rejectWithValue ile gelen { key } ya da { text } değerini kullanıcı metnine çevirir. */
const rejectionText = (action) => {
  const payload = action.payload;
  if (payload?.text) return payload.text;
  if (payload?.key) return i18n.t(payload.key);
  return humanizeError(action.error);
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    resetLoginState: (state) => {
      state.login.state = { loading: false, success: false, error: null };
      state.login.auth = null;
    },
    resetLogoutState: (state) => {
      state.logout = { loading: false, success: false, error: null };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.login.state = {
          loading: true,
          success: false,
          error: null,
        };
      })
      .addCase(login.fulfilled, (state, action) => {
        state.login = {
          state: { loading: false, success: true, error: null },
          auth: action.payload,
        };
      })
      .addCase(login.rejected, (state, action) => {
        state.login.state = {
          loading: false,
          success: false,
          error: rejectionText(action),
        };
      })
      .addCase(logout.pending, (state) => {
        state.logout = { loading: true, success: false, error: null };
      })
      .addCase(logout.fulfilled, (state) => {
        state.logout = { loading: false, success: true, error: null };
      })
      .addCase(logout.rejected, (state) => {
        state.logout = {
          loading: false,
          success: false,
          error: i18n.t("errors.logoutFailed"),
        };
      });
  },
});

export const login = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    let response;
    try {
      response = await api.get(
        `https://liwapos.com/samba.mobil/Json/JsonSambaPatronLogin?email=${
          credentials.email
        }&password=${encodeURIComponent(credentials.password)}`
      );
    } catch (err) {
      return rejectWithValue({ text: humanizeError(err) });
    }

    const user = Array.isArray(response.data) ? response.data[0] : null;
    if (response.status !== 200 || !user) {
      return rejectWithValue({ key: "errors.loginFailed" });
    }
    if (!user.user_id) {
      return rejectWithValue(
        user.Message
          ? { text: user.Message }
          : { key: "errors.invalidCredentials" }
      );
    }
    if (user.usersType === 0) {
      return rejectWithValue({ key: "errors.dealerLogin" });
    }

    try {
      const res = await api.post(`${port}/token/generate_token`, {
        email: credentials.email,
        password: encodeURIComponent(credentials.password),
      });
      if (!res.data?.token) {
        return rejectWithValue({ key: "errors.loginFailed" });
      }
      // Sunucu yanıtında parola alanı olsa bile oturum deposuna yazılmaz.
      const { password, Password, ...safeUser } = user;
      return { ...safeUser, token: res.data.token };
    } catch (err) {
      return rejectWithValue({ text: humanizeError(err) });
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  await new Promise((resolve) => setTimeout(resolve, 300));
  return null;
});

export default authSlice.reducer;
export const { resetLoginState, resetLogoutState } = authSlice.actions;
